// Copyright (c) Microsoft Corporation. All rights reserved.

import "../WegoThemed.css"

import { MeetingType, PreMeetingType } from "./WeGoHostedProps";
import React, { Component } from "react";
import { WegoContext, WegoContextType } from "../misc/WegoContext";

import TeamsContextProvider from "../misc/TeamsContextProvider";
import WeGoConstants from "../misc/WegoConstants";
import WegoConfiguaration from "../WegoConfiguration";

type WegoTeamsHostProps = {
    appId: string;
    appName: string;
    appMeetingType: MeetingType;
    appPreMeetingType: PreMeetingType;
    wegoConfiguration: WegoConfiguaration;
}

type WegoTeamsHostState = {
    wegoContextInitialized: boolean;
    wegoContext: WegoContextType | null;
}

export default class WegoTeamsHost extends Component<WegoTeamsHostProps, WegoTeamsHostState> {
    contextHelper: Promise<WegoContextType>;
    state: WegoTeamsHostState = { wegoContextInitialized: false, wegoContext: null };

    constructor(props: WegoTeamsHostProps) {
        super(props);
        this.contextHelper = new TeamsContextProvider(props.appId, props.wegoConfiguration).getTeamsContext();
    }

    componentDidMount() {
        this.contextHelper.then(wegoContext => {
            this.setState({
                wegoContextInitialized: true,
                wegoContext: wegoContext
            })
        }).catch((reason) => {
            alert(reason);
        });
    }

    render() {
        if (this.state.wegoContextInitialized) {
            console.log(this.state);
            const themeClassname = this.state.wegoContext?.teamsTheme === "dark" ? "wego-themed-container-dark" : "wego-themed-container-light"
            const { SidePanel, Stage, PreMeeting } = WeGoConstants.Surfaces;
            const frameContext = this.state.wegoContext!.teamsFrameContext!;
            const PreMeetingComponent = this.props.appPreMeetingType;
            const MeetingComponent = this.props.appMeetingType;

            switch (frameContext) {
                case SidePanel:
                    return (
                        <WegoContext.Provider value={this.state.wegoContext}>
                            <div className="centered-container">
                                <MeetingComponent
                                    surface={SidePanel}
                                    appId={this.state.wegoContext?.appId!}
                                    userId={this.state.wegoContext?.userId!}
                                    userPrincipalName={this.state.wegoContext?.userPrincipalName!}
                                    meetingId={this.state.wegoContext?.meetingId!}
                                />
                            </div>
                        </WegoContext.Provider>
                    );

                case Stage:
                    return (
                        // Lobby is always dark, theme only applies to premeeting.
                        <WegoContext.Provider value={this.state.wegoContext}>
                            <div className="centered-container-stage">
                                <MeetingComponent
                                    surface={Stage}
                                    appId={this.state.wegoContext?.appId!}
                                    userId={this.state.wegoContext?.userId!}
                                    userPrincipalName={this.state.wegoContext?.userPrincipalName!}
                                    meetingId={this.state.wegoContext?.meetingId!}
                                />
                            </div>
                        </WegoContext.Provider>
                    );

                case PreMeeting:
                    return (
                        // Lobby is always dark, theme only applies to premeeting.
                        <WegoContext.Provider value={this.state.wegoContext}>
                            <div className="App ms-Fabric">
                                <div className={themeClassname}>
                                    <PreMeetingComponent
                                        appId={this.props.appId}
                                        appName={this.props.appName}
                                        meetingId={this.state.wegoContext!.meetingId}
                                        userPrincipalName={this.state.wegoContext!.userPrincipalName}
                                    />
                                </div>
                            </div>
                        </WegoContext.Provider>
                    );

                default:
                    return null;
            }
        } else {
            return <></>
        }
    }
}